<template>
  <div class="news-editor">
    <el-form :model="newsForm" label-width="80px">
      <!-- 标题 -->
      <el-form-item label="标题">
        <el-input v-model="newsForm.title" placeholder="输入新闻标题" />
      </el-form-item>
      <!-- Markdown 编辑器 -->
      <el-form-item label="内容">
        <MdEditor
          v-model="newsForm.content"
          :preview="false"
          height="500px"
        />
      </el-form-item>
      <!-- 操作按钮 -->
      <el-form-item>
        <el-button type="primary" @click="save('draft')">保存草稿</el-button>
        <el-button type="success" @click="save('published')">发布</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script setup>
import { ref } from 'vue'
import { ElMessage } from 'element-plus'
import axios from 'axios'
// ⚠️ 注意：不是 default！必须用 { MdEditor }
import { MdEditor } from 'md-editor-v3'
import 'md-editor-v3/lib/style.css'
const newsForm = ref({
  title: '',
  content: '',
  author: 'Admin'
})
const save = async (status) => {
  try {
    await axios.post('/news/save', {
      ...newsForm.value,
      status
    })
    ElMessage.success('保存成功')
  } catch (e) {
    console.error(e)
    ElMessage.error('保存失败')
  }
}
</script>
<style scoped>
.news-editor {
  padding: 20px;
}
</style>
